export const tagsRel = {
  headers: [
    { key: 'cnpj', label: 'CNPJ' },
    { key: 'empresa', label: 'Empresa' },
    { key: 'ano', label: 'Ano' },
    {
      key: 'censoDiversidade',
      label:
        'A minha empresa realiza pesquisa de censo de diversidade'
    },
    {
      key: 'periodicidadeCenso',
      label:
        'A periodicidade da pesquisa de censo de diversidade é'
    },
    {
      key: 'censoDiversidadeNoAno',
      label:
        'A minha empresa realizou neste ano de referência pesquisa de censo de diversidade'
    },
    { key: 'baseInformacao', label: 'Essas informações são baseadas em:' },
    {
      key: 'infosVindasAdmissao',
      label:
        'O registro admissional continha informações de raça, orientação sexual e identidade de gênero separadamente'
    },
    {
      key: 'totalLider',
      label: 'Número total de empregados em posição de liderança'
    },
    {
      key: 'totalAltaLider',
      label: 'Número total de empregados em posição de alta liderança'
    },
    { key: 'mulheres', label: 'Número de mulheres' },
    {
      key: 'mulheresLider',
      label: 'Número de mulheres em posição de liderança'
    },
    {
      key: 'mulheresAltaLider',
      label: 'Número de mulheres em posição de alta liderança'
    },
    { key: 'pcds', label: 'Número de PCDs' },
    { key: 'pcdsLider', label: 'Número de PCDs em posição de liderança' },
    {
      key: 'pcdsAltaLider',
      label: 'Número de PCDs em posição de alta liderança'
    },
    {
      key: 'pretosPardos',
      label: 'Número de pessoas que se autodeclaram negras (pretas ou pardas)'
    },
    {
      key: 'pretosPardosLider',
      label:
        'Número de pessoas que se autodeclaram negras (pretas ou pardas) em posição de liderança'
    },
    {
      key: 'pretosPardosAltaLider',
      label:
        'Número de pessoas que se autodeclaram negras (pretas ou pardas) em posição de alta liderança'
    },
    { key: 'lgbtqia', label: 'Número de LGBTQIA+' },
    {
      key: 'lgbtqiaLider',
      label: 'Número de LGBTQIA+ em posição de liderança'
    },
    {
      key: 'lgbtqiaAltaLider',
      label: 'Número de LGBTQIA+ em posição de alta liderança'
    },
    {
      key: 'iniciativaDiversi',
      label:
        'Empresa realizou neste ano iniciativas para promover a diversidade para pessoas LGBTQIA+, pessoas pretas ou pardas, pessoas com deficiência ou mulheres'
    },
    {
      key: 'programaDiversi',
      label:
        'Empresa possui programa de diversidade e inclusão'
    },
    {
      key: 'beneficiosDiversi',
      label:
        'Empresa oferece benefícios específicos para grupos de diversidade'
    },
    {
      key: 'investimentoTreinamento',
      label:
        'Investimento em treinamento para diversidade e inclusão'
    },
    {
      key: 'publico',
      label:
        'O público alvo das ações de diversidade e inclusão é'
    },
    {
      key: 'atividade',
      label:
        'As atividades de diversidade e inclusão são'
    },
    {
      key: 'acessBanheiro',
      label:
        'A empresa possui banheiros acessíveis'
    },
    {
      key: 'acessVestiario',
      label:
        'A empresa possui vestiários acessíveis'
    },
    {
      key: 'acessSalaDescanso',
      label:
        'A empresa possui sala de descanso acessível'
    },
    {
      key: 'acessSalaExtracaoLeite',
      label:
        'A empresa possui sala de extração de leite acessível'
    },
    {
      key: 'investimentoAcoes',
      label:
        'Investimento em ações de acessibilidade'
    },
    { key: 'obsDi', label: 'Boa pratica de D&I realizada do ano' },
    { key: 'obsGeral', label: 'Comentário ou informações importantes' },
    { key: 'createdAt', label: 'Inserido' },
    { key: 'updatedAt', label: 'Atualizado' }
  ]
};

export const baseInfo = [
  {
    id: 'autoDeclara',
    label: 'Auto Declaração'
  },
  {
    id: 'registAdmiss',
    label: 'Registro Admissional'
  }
];

export const periodicidadeCenso = [
  {
    id: 'anual',
    label: 'Anualmente'
  },
  {
    id: 'bienal',
    label: 'A cada 2 anos'
  },
  {
    id: 'trienal',
    label: 'A cada 3 anos'
  }
];
